import { render } from "./PreviewStory.vue?vue&type=template&id=2f232c48"
import script from "./PreviewStory.vue?vue&type=script&lang=js"
export * from "./PreviewStory.vue?vue&type=script&lang=js"

import "./PreviewStory.vue?vue&type=style&index=0&id=2f232c48&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__